import { APIClientInterface, GroupServiceInterface } from '../types'

export default class GroupService implements GroupServiceInterface {
	constructor(private client: APIClientInterface) {}

	change(group: string): Promise<void> {
		return this.client.post(`/group-change`, JSON.stringify({ group }))
	}
}
